const getMatchHistory = () => Promise.resolve().then(() => JSON.parse(localStorage.getItem('matchHistory') ?? '[]'));

const setMatchHistory = matches => Promise.resolve().then(() => localStorage.setItem('matchHistory', JSON.stringify(matches)));

export const appendMatchHistory = async match => setMatchHistory((await getMatchHistory()).concat(match));